
import moment from 'moment'
import { EncodeURL, authHeader, responseCheck, AuthURL } from './index'
import instance from './http'
export function getCountryandProvince() {
    if (localStorage.getItem('countries') === null) {
        instance
            .get(EncodeURL + 'country', {
                headers: authHeader()
            })
            .then(response => {
                const parsed = JSON.stringify(response.data.data);
                localStorage.setItem('countries', parsed);
            })
            .catch(function (error) {
                responseCheck(error.response.status);
            })
    }
    if (localStorage.getItem('provinces') === null) {
        instance
            .get(EncodeURL + 'province', {
                headers: authHeader()
            })
            .then(response => {
                const parsed = JSON.stringify(response.data.data);
                localStorage.setItem('provinces', parsed);
            })
            .catch(function (error) {
                responseCheck(error.response.status);
            })
    }

    if (localStorage.getItem('orgtype') === null) {
        instance
            .get(EncodeURL + 'orgtype', {
                headers: authHeader()
            })
            .then(response => {
                const parsed = JSON.stringify(response.data.data);
                localStorage.setItem('orgtype', parsed);
            })
            .catch(function (error) {
                responseCheck(error.response.status);
            })
    }

    if (localStorage.getItem('transportationtype') === null) {
        instance
            .get(EncodeURL + 'transportationtype', {
                headers: authHeader()
            })
            .then(response => {
                const parsed = JSON.stringify(response.data.data);
                localStorage.setItem('transportationtype', parsed);
            })
            .catch(function (error) {
                responseCheck(error.response.status);
            })

    }

    if (localStorage.getItem('realestatetype') === null) {
        instance
            .get(EncodeURL + 'realestatetype', {
                headers: authHeader()
            })
            .then(response => {
                const parsed = JSON.stringify(response.data.data);
                localStorage.setItem('realestatetype', parsed);
            })
            .catch(function (error) {
                responseCheck(error.response.status);
            })

    }

    if (localStorage.getItem('papertype') === null) {
        instance
            .get(EncodeURL + 'papertype', {
                headers: authHeader()
            })
            .then(response => {
                const parsed = JSON.stringify(response.data.data);
                localStorage.setItem('papertype', parsed);
            })
            .catch(function (error) {
                responseCheck(error.response.status);
            })

    }

    if (localStorage.getItem('eventtype') === null) {
        instance
            .get(EncodeURL + 'eventtype', {
                headers: authHeader()
            })
            .then(response => {
                const parsed = JSON.stringify(response.data.data);
                localStorage.setItem('eventtype', parsed);
            })
            .catch(function (error) {
                responseCheck(error.response.status);
            })

    }

    if (localStorage.getItem('eventregion') === null) {
        instance
            .get(EncodeURL + 'eventregion', {
                headers: authHeader()
            })
            .then(response => {
                const parsed = JSON.stringify(response.data.data);
                localStorage.setItem('eventregion', parsed);
            })
            .catch(function (error) {
                responseCheck(error.response.status);
            })

    }

    if (localStorage.getItem('sources') === null) {
        instance
            .get(EncodeURL + 'sources', {
                headers: authHeader()
            })
            .then(response => {
                const parsed = JSON.stringify(response.data.data);
                localStorage.setItem('sources', parsed);
            })
            .catch(function (error) {
                responseCheck(error.response.status);
            })

    }

    if (localStorage.getItem('infoacc') === null) {
        instance
            .get(EncodeURL + 'infoacc', {
                headers: authHeader()
            })
            .then(response => {
                const parsed = JSON.stringify(response.data.data);
                localStorage.setItem('infoacc', parsed);
            })
            .catch(function (error) {
                responseCheck(error.response.status);
            })

    }

    if (localStorage.getItem('telephonetype') === null) {
        instance
            .get(EncodeURL + 'Telephonetype', {
                headers: authHeader()
            })
            .then(response => {
                const parsed = JSON.stringify(response.data.data);
                localStorage.setItem('telephonetype', parsed);
            })
            .catch(function (error) {
                responseCheck(error.response.status);
            })
    }

    if (localStorage.getItem('major') === null) {
        instance
            .get(EncodeURL + 'MajorClassification', {
                headers: authHeader()
            })
            .then(response => {
                const parsed = JSON.stringify(response.data.data);
                localStorage.setItem('major', parsed);
            })
            .catch(function (error) {
                responseCheck(error.response.status);
            })
    }

    if (localStorage.getItem('users') === null) {
        instance
            .get(AuthURL + 'UserList', {
                headers: authHeader()
            })
            .then(response => {
                const parsed = JSON.stringify(response.data);
                localStorage.setItem('users', parsed);
            })
            .catch(function (error) {
                responseCheck(error.response.status);
            })
    }

}
export function getlocalstorageTelephoneType() {
    if (localStorage.getItem('telephonetype') === null) {
        instance
            .get(EncodeURL + 'Telephonetype', {
                headers: authHeader()
            })
            .then(response => {
                const parsed = JSON.stringify(response.data.data);
                localStorage.setItem('telephonetype', parsed);
            })
            .catch(function (error) {
                responseCheck(error.response.status);
            })
    }
    let countries = JSON.parse(localStorage.getItem('telephonetype'));
    return countries
}
export function getLocalstorageMajorClassification() {
    if (localStorage.getItem('major') === null) {
        instance
            .get(EncodeURL + 'MajorClassification', {
                headers: authHeader()
            })
            .then(response => {
                const parsed = JSON.stringify(response.data.data);
                localStorage.setItem('major', parsed);
            })
            .catch(function (error) {
                responseCheck(error.response.status);
            })
    }
    let MajorClassification = JSON.parse(localStorage.getItem('major'));
    return MajorClassification
}
export function getlocalstorageSources() {
    if (localStorage.getItem('sources') === null) {
        instance
            .get(EncodeURL + 'sources', {
                headers: authHeader()
            })
            .then(response => {
                const parsed = JSON.stringify(response.data.data);
                localStorage.setItem('sources', parsed);
            })
            .catch(function (error) {
                responseCheck(error.response.status);
            })
    }
    let countries = JSON.parse(localStorage.getItem('sources'));
    return countries
}
export function getlocalstorageInfoAcc() {
    if (localStorage.getItem('infoacc') === null) {
        instance
            .get(EncodeURL + 'infoacc', {
                headers: authHeader()
            })
            .then(response => {
                const parsed = JSON.stringify(response.data.data);
                localStorage.setItem('infoacc', parsed);
            })
            .catch(function (error) {
                responseCheck(error.response.status);
            })
    }
    let countries = JSON.parse(localStorage.getItem('infoacc'));
    return countries
}
export function getlocalstorageEventRegion() {
    if (localStorage.getItem('eventregion') === null) {
        instance
            .get(EncodeURL + 'eventregion', {
                headers: authHeader()
            })
            .then(response => {
                const parsed = JSON.stringify(response.data.data);
                localStorage.setItem('eventregion', parsed);
            })
            .catch(function (error) {
                responseCheck(error.response.status);
            })

    }
    let countries = JSON.parse(localStorage.getItem('eventregion'));
    return countries
}
export function getlocalstorageEventType() {
    if (localStorage.getItem('eventtype') === null) {
        instance.get(EncodeURL + 'eventtype', {
            headers: authHeader()
        })
            .then(response => {
                const parsed = JSON.stringify(response.data.data);
                localStorage.setItem('eventtype', parsed);
            })
            .catch(function (error) {
                responseCheck(error.response.status);
            })
    }
    let countries = JSON.parse(localStorage.getItem('eventtype'));
    return countries
}
export function getlocalstoragePaperType() {
    if (localStorage.getItem('papertype') === null) {
        instance
            .get(EncodeURL + 'papertype', {
                headers: authHeader()
            })
            .then(response => {
                const parsed = JSON.stringify(response.data.data);
                localStorage.setItem('papertype', parsed);
            })
            .catch(function (error) {
                responseCheck(error.response.status);
            })

    }
    let countries = JSON.parse(localStorage.getItem('papertype'));
    return countries

}
export function getlocalstorageRealEstateType() {
    if (localStorage.getItem('realestatetype') === null) {
        instance
            .get(EncodeURL + 'realestatetype', {
                headers: authHeader()
            })
            .then(response => {
                const parsed = JSON.stringify(response.data.data);
                localStorage.setItem('realestatetype', parsed);
            })
            .catch(function (error) {
                responseCheck(error.response.status);
            })
        let countries = JSON.parse(localStorage.getItem('realestatetype'));
        return countries
    }
    let countries = JSON.parse(localStorage.getItem('realestatetype'));
    return countries
}
export function getlocalstorageTransportationType() {
    if (localStorage.getItem('transportationtype') === null) {
        instance
            .get(EncodeURL + 'transportationtype', {
                headers: authHeader()
            })
            .then(response => {
                const parsed = JSON.stringify(response.data.data);
                localStorage.setItem('transportationtype', parsed);
            })
            .catch(function (error) {
                responseCheck(error.response.status);
            })

    }
    let countries = JSON.parse(localStorage.getItem('transportationtype'));
    return countries
}
export function getlocalstorageOrgType() {
    if (localStorage.getItem('countries') === null) {
        instance
            .get(EncodeURL + 'orgtype', {
                headers: authHeader()
            })
            .then(response => {
                const parsed = JSON.stringify(response.data.data);
                localStorage.setItem('orgtype', parsed);
            })
            .catch(function (error) {
                responseCheck(error.response.status);
            })
    }
    let countries = JSON.parse(localStorage.getItem('orgtype'));
    return countries
}
export function getlocalstorageCountry() {
    if (localStorage.getItem('countries') === null) {
        instance
            .get(EncodeURL + 'country', {
                headers: authHeader()
            })
            .then(response => {
                const parsed = JSON.stringify(response.data.data);
                localStorage.setItem('countries', parsed);
            })
            .catch(function (error) {
                responseCheck(error.response.status);
            })
    }
    let countries = JSON.parse(localStorage.getItem('countries'));
    return countries
}
export function getlocalstorageProvince() {
    if (localStorage.getItem('provinces') === null) {
        instance
            .get(EncodeURL + 'province', {
                headers: authHeader()
            })
            .then(response => {
                const parsed = JSON.stringify(response.data.data);
                localStorage.setItem('provinces', parsed);
            })
            .catch(function (error) {
                responseCheck(error.response.status);
            })
    }
    let provinces = JSON.parse(localStorage.getItem('provinces'));
    return provinces

}
export function getListofUsers() {
    if (localStorage.getItem('users') === null) {
        instance
            .get(AuthURL + 'UserList', {
                headers: authHeader()
            })
            .then(response => {
                const parsed = JSON.stringify(response.data);
                localStorage.setItem('users', parsed);
            })
            .catch(function (error) {
                responseCheck(error.response.status);
            })
    }
    let provinces = JSON.parse(localStorage.getItem('users'));
    return provinces
}
export function checkfolder() {
    let retval
    instance
        .get(EncodeURL + 'checkFolder', {
            headers: authHeader()
        })
        .then(response => {
            if (response.data.alive) {
                window.console.log(response.data.alive)
                retval = true
            } else {
                window.console.log(response.data.alive)
                retval = false
            }
        })
        .catch(function (error) {
            responseCheck(error.response.status);
        })

    return retval
}
export function formatdate(value) {
    if (value) {
        return moment(String(value)).format('YYYY-MM-DD')
    }
}

export function getLocalstorageFinancialTypes(){
    if (localStorage.getItem('financialtype') === null) {
        instance
            .get(EncodeURL + 'financialtype', {
                headers: authHeader()
            })
            .then(response => {
                const parsed = JSON.stringify(response.data.data);
                localStorage.setItem('financialtype', parsed);
            })
            .catch(function (error) {
                responseCheck(error.response.status);
            })
    }
    let financialtype = JSON.parse(localStorage.getItem('financialtype'));
    return financialtype
}
